module.exports = __webpack_public_path__ + "img/spriteHalloween.1422adef.svg";